/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { List, ListContent, ListIcon, ListItem } from 'semantic-ui-react'
import { useTranslation } from 'react-i18next'

const ConfirmPasswordInteractiveHint = ({ password, confirmPassword }) => {
    const [t] = useTranslation()
    const passwordsMatch = password === confirmPassword && password.length > 0

    if (confirmPassword.length === 0) {
        return null
    }

    return (
      <List>
            <ListItem
              css={css`
                color: ${passwordsMatch ? 'green' : 'grey'};
                  font-size: .9em;
            `}>
                <ListIcon name={passwordsMatch ? 'check' : 'remove'} />
                <ListContent>{passwordsMatch ? t('reset_password.passwords_match') : t('reset_password.passwords_not_match')}</ListContent>
            </ListItem>
      </List>
    )
}

export { ConfirmPasswordInteractiveHint }
